import React from 'react';
import stringHelper from '../../../../Helpers/stringHelper';
import TpSurveyService from '../../../../Services/tpSurveyService';
import ErrorMessage from '../../../ErrorMessage';
import SelectFieldCheckbox from './SelectFieldCheckbox';

export default class TpSurveySelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    idFilter: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.idFilter !== prevProps.idFilter) {
      this.populateListData();
    }
  }

  populateListData() {
    if (!this.props.idFilter) {
      this.setState({ selectValues: [] });
      return;
    }

    TpSurveyService.GetSurveySelectList(null, this.props.idFilter)
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result
          .sort((a, b) => (a.thirdPartySurveyName > b.thirdPartySurveyName ? 1 : -1))
          .forEach((survey) => {
            optValues.push({
              label: survey.thirdPartySurveyName + stringHelper.toBracket(survey.thirdPartySurveyId),
              value: `${survey.tpSurveyId}//${survey.clientId}`,
              disabled: false,
            });
          });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('TSUS56');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
